import { useEffect, useMemo } from "react";

import BasicDataTable from "../../components/DataTable/BasicDataTable";
import { cashAdjustmentColumns } from "../../features/cash/cashAdjustmentColumns";

import { useCashMovements } from "../../hooks/cash/useCashMovements";
import { useCashSession } from "../../hooks/cash/useCashSession";

import { CashMovementType } from "../../types/cash/CashMovementType";

const CashAdjustmentHistory = () => {

  const { movements, getSessionMovements } = useCashMovements();
  const { activeSession } = useCashSession();

  const columns = useMemo(() => cashAdjustmentColumns, []);

  /**
   * 📜 Cargar ajustes (IN + OUT)
   */
  useEffect(() => {

    if (activeSession?.id) {

      getSessionMovements(
        activeSession.id,
        [
          CashMovementType.ADJUSTMENT_IN,
          CashMovementType.ADJUSTMENT_OUT
        ]
      );

    }

  }, [activeSession]);

  /**
   * ❌ SIN SESIÓN → NO RENDERIZA NADA
   */
  if (!activeSession) {
    return null;
  }

  return (

    <BasicDataTable
      columns={columns}
      data={movements}
      noDataMessage="No hay ajustes registrados."
    />

  );

};

export default CashAdjustmentHistory;